import type { SuperSearchStatus } from '@/api/types';

const currency = new Intl.NumberFormat('en-AU', {
  style: 'currency',
  currency: 'AUD',
  maximumFractionDigits: 0,
});

export const money = (value: number): string => currency.format(value ?? 0);

export function when(value: string | null | undefined): string {
  if (!value) return '—';

  const date = new Date(value.endsWith('Z') ? value : `${value}Z`);
  const minutes = Math.round((Date.now() - date.getTime()) / 60000);

  if (minutes < 1) return 'just now';
  if (minutes < 60) return `${minutes}m ago`;
  if (minutes < 60 * 24) return `${Math.round(minutes / 60)}h ago`;
  if (minutes < 60 * 24 * 7) return `${Math.round(minutes / (60 * 24))}d ago`;

  return date.toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: '2-digit' });
}

export const exact = (value: string | null | undefined): string =>
  value ? new Date(value.endsWith('Z') ? value : `${value}Z`).toLocaleString('en-AU') : '—';

/** Plain-English status, because "ClientNotOnAgentList" is a code, not an explanation. */
export const statusLabel: Record<SuperSearchStatus, string> = {
  Pending: 'Queued',
  Running: 'Running',
  Succeeded: 'Synced',
  ContactNotFound: 'No contact',
  NoTfn: 'No TFN',
  ClientNotOnAgentList: 'Not on client list',
  AtoNotAuthenticated: 'Waiting on myGovID',
  OntraportPushFailed: 'Ontraport write failed',
  Failed: 'Failed',
  AwaitingLodgement: 'Awaiting lodgement',
  AtoUnavailable: 'ATO unavailable',
  QueuedAtAto: 'Queued at ATO',
};

/**
 * Three tiers, not eleven colours: green means done, amber means it will resolve itself,
 * red means a human has to do something.
 */
export const statusTone: Record<SuperSearchStatus, 'good' | 'waiting' | 'bad'> = {
  Pending: 'waiting',
  Running: 'waiting',
  Succeeded: 'good',
  ContactNotFound: 'bad',
  NoTfn: 'bad',
  ClientNotOnAgentList: 'bad',
  AtoNotAuthenticated: 'waiting',
  OntraportPushFailed: 'waiting',
  Failed: 'bad',
  AwaitingLodgement: 'waiting',
  AtoUnavailable: 'waiting',
  QueuedAtAto: 'waiting',
};
